import { render, staticRenderFns } from "./introdution.vue?vue&type=template&id=3738305b&scoped=true"
import script from "./introdution.vue?vue&type=script&lang=js"
export * from "./introdution.vue?vue&type=script&lang=js"
import style0 from "./introdution.vue?vue&type=style&index=0&id=3738305b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738305b",
  null
  
)

export default component.exports